import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
const getDentalSuppliersQuery = gql`query get_dental_suppliers{
  dental_suppliers {
    id
    name
    phone
    email
    profile_image
    business_name
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetDentalSuppliersService {
/* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }
/* -------------------------- Get Dental Suppliers -------------------------- */
  getDentalSuppliers(): Observable<any>{
    return this.apollo.use('external').query({
      query: getDentalSuppliersQuery
    }).pipe(pluck('data', 'dental_suppliers'));
  }
}
